export default __webpack_public_path__ + "static/media/surfboard_dark.4b95ca84.png";